module.exports = __webpack_public_path__ + "img/H000010_sprout.c1a75c91.png";